import { useTranslation } from 'react-i18next';
import { SmallButton } from 'components/Shared/Buttons';
import Spacer from 'components/Shared/Spacer';
import MonthlyPayment from 'components/Shared/MonthlyPayment';
import css from 'styled-jsx/css';
import numeral from 'numeral';
import VdpEventContext from 'contexts/VdpEventContext';
import { useContext } from 'react';
import useEvents from 'lib/hooks/useEvents';
import tapEvent from 'lib/Tracking/Vdp/StickyHeader/TapEvent';
import useOptimizelyDecisions from 'lib/hooks/useOptimizelyDecisions';
import { MiniVdpViewModel } from './types';
import styles from './styles';

const contactButtonCss = css.resolve`
  width: 182px;
`;

const StickyHeader = ({
  year,
  make,
  model,
  mileage: mileageUnformatted,
  city,
  state,
  primaryPhotoUrl,
  price,
  monthlyPayment,
  submitState,
  onClick,
}: MiniVdpViewModel): JSX.Element => {
  const { t } = useTranslation();
  const { trackingParams } = useContext(VdpEventContext);
  const logger = useEvents();
  const { testLeadCTA } = useOptimizelyDecisions();
  const translationVariant = testLeadCTA ? 'vdp.requestInfo' : 'vdp.checkAvailability';

  return (
    <div className="sticky-header" data-testid="vdp-sticky-header">
      <div className="details">
        <div className="left-container">
          <img
            className="primary-photo"
            src={primaryPhotoUrl || 'https://www.autolist.com/assets/listings/default_car.jpg'}
          />
          <div className="vehicle-details-container">
            <div className="primary-details">
              {year} {make} {model}
            </div>
            <div className="secondary-details">
              {t('vdp.mileageHumanized', { mileage: mileageUnformatted })} | {city},{state}
            </div>
          </div>
        </div>
        <div className="right-container">
          <div className="price-container">
            <div className="price">{numeral(price).format('$0,0')}</div>
            {monthlyPayment && <MonthlyPayment monthlyPayment={monthlyPayment} />}
          </div>
          <Spacer size="26px" />
          <SmallButton
            normalText={t(translationVariant)}
            disabledText={t('vdp.sellerContacted')}
            state={submitState}
            onClick={(): void => {
              logger.log(tapEvent({ action: 'email', trackingParams }));
              onClick();
            }}
            className="contact-bar-button"
          />
        </div>
      </div>
      <style jsx>{styles}</style>
      {contactButtonCss.styles}
    </div>
  );
};

export default StickyHeader;
